export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  clinicianId: number;
  createdDate: string;
  clinicId: number;
  clinicianCode: string;
  createdByUserId: number;
  clinicianStatus: number;
  clinicianName: string;
  clinicianMinistry: string;
  clinicianMinistryId: number;
};

export type SaveResponseType = {};

export type LabListType = {
  name: string;
  id: number;
};

export type MasterFormDataType = {
  clinicanCode: string;
  ClincianName: { empId: number; empName: string } | null;
  ministry: { id: number; ministryName: string } | null;
  clinicianStatus: number;
};

export type MasterDataType = {
  clinicianId: number;
  clinicianCode: string;
  clinicianName: string;
  clinicMinistry: string;
  clinicId: number;
  clinicianStatus: number;
  createdByUserId: number;
};

export const initialFormData: MasterFormDataType = {
  clinicanCode: "",
  ClincianName: null,
  ministry: null,
  clinicianStatus: 1,
};
